import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { IAuraSoftwareSuiteLicensesInfo } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import AuraSoftwareSuiteLicensesAssignedInfo from "../AuraSoftwareSuiteLicensesAssignedInfo/AuraSoftwareSuiteLicensesAssignedInfo";

export interface IAuraSoftwareSuiteLicensesAssigned{
    auraSoftwareSuiteLicenses: IAuraSoftwareSuiteLicensesInfo[];
}

const AuraSoftwareSuiteLicensesAssigned: React.FC<IAuraSoftwareSuiteLicensesAssigned> = ({auraSoftwareSuiteLicenses}) => {
    return(
        <>
            <GridViewCollapase title="Assigned" id="cloud-storage-licenses-assigned">
                <div>
                    <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Suite</th>
                                 <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Sign up date </th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Expiration date</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Partner</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Clinic</th>
                               
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                auraSoftwareSuiteLicenses.map((license: IAuraSoftwareSuiteLicensesInfo, index: number) => (
                                    <tr key={index}>
                                        <AuraSoftwareSuiteLicensesAssignedInfo auraSoftwareSuiteLicenses={license}/> 
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </GridViewCollapase>
        </>
    );
}

export default AuraSoftwareSuiteLicensesAssigned;